import axios from "axios";
import Configuration from "@common/Configuration";
import RestAPI from "@common/rest/RestAPI";
import { getSelectedSubTenant } from "./SubTenantStore";

export type TeamRef = {
  id: number;
  name: string;
};

export type MeWebResponse = {
  id: number;
  username: string;
  firstName: string;
  lastName: string;
  email: string;
  roles: string[];
  privileges: string[];
  teams: TeamRef[];
};

// `/me` NON è escluso dall'ActiveSubTenantFilter (salta solo `oauth/`, `auth/`,
// `system/`): senza `X-Tenant` il backend sceglie 'prod' se è nel claim, e
// risponderebbe coi ruoli del nucleo sbagliato; con ≥2 nuclei e nessun 'prod'
// risponde 409 SUBTENANT_REQUIRED. L'header va quindi messo qui a mano, perché
// questa chiamata resta su axios grezzo apposta — passare da RestAPI la
// farebbe rientrare nell'interceptor 401 durante il bootstrap.
//
// Il valore viene dallo store, che il chiamante deve aver già riconciliato col
// claim: NON usare `pickDefault` sul token, scarterebbe la scelta dell'utente.
export async function fetchMe(token: string): Promise<MeWebResponse> {
  const baseUrl = String(Configuration.VITE_CONFIG_API_BASE ?? "");
  const subTenant: string | null = getSelectedSubTenant();
  const response = await axios.get<MeWebResponse>(`${baseUrl}/me`, {
    headers: {
      Authorization: `Bearer ${token}`,
      ...(subTenant ? { "X-Tenant": subTenant } : {}),
    },
  });
  return response.data;
}

// Rilettura del proprio profilo per l'uso normale in app. Esiste accanto a `fetchMe`
// e non al suo posto: quella prende il token per parametro apposta, per non passare
// dall'interceptor 401 durante il bootstrap. Qui il token c'è già, in RestAPI.
export async function fetchMyProfile(): Promise<MeWebResponse> {
  const response = await RestAPI.get<MeWebResponse>("/me");
  return response.data;
}

/** Campi omessi = invariati (UpdateOwnProfileRequest: «Campi null = invariati»). */
export type OwnProfileUpdate = {
  firstName?: string;
  lastName?: string;
  email?: string;
};

// Self-service identità: è il rimpiazzo dell'edit rimosso da `PUT /admin/users/{id}`,
// che ora accetta solo {enabled}. Passa dall'istanza condivisa RestAPI — che inietta
// Authorization e X-Tenant — e non dallo stile a header manuali di `fetchMe`, che
// esiste solo per non rientrare nell'interceptor 401 durante il bootstrap.
export async function updateMyProfile(update: OwnProfileUpdate): Promise<void> {
  await RestAPI.put("/me/profile", update);
}
